import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import { components } from 'react-select';

// TODO Fix any
export const FnDropdownIndicator: FC<any> = (props) => {
  return (
    components.DropdownIndicator ? (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={props.selectProps.menuIsOpen ? faAngleUp : faAngleDown} />
      </components.DropdownIndicator>
    ) : null
  );
};
